app.service('answer',function(modal, validate, login, loading, cookie, comment, captchaService, localStorage, text) {

	function addInfo(question){
		var itemValue = localStorage.getItem('qa'+question) || false;
		if(itemValue){
			var text=itemValue.split('|')[1];
			var box=$('#answer-form-box-'+question);
			if(box.length){
				var div=box.find('.success-answer');
				if(!div.length){
					div=$('<div/>').addClass('success-box success-answer').attr('id','success-answer-'+question).html(text).appendTo(box);
					show(question);
				}
			}
		}
	}
	function loadFormSuccess(question, focus){
		var div=$('#answer-form-box-'+question);
		var form=div.find('form');
		validate.task('answer', {
			form:form,
			success:function(){
				send(form);
			}
		});
		if(focus){
			form.find('textarea').focus().click();
		}
		addAnswerCaptcha(div);
	}
	function addAnswerCaptcha($div) {
		let $captcha = $div.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function loadForm(question, focus){
		var div=$('#answer-form-box-'+question);
		div.addClass('loading');
		show(question);
		$.ajax({
			url:'/product-answer-form.ltr',
			type:'GET',
			data:{
				questionToken:question
			},
			success:function(html){
				div.html(html);
				loadFormSuccess(question, focus);
			},
			complete:function(){
				div.removeClass('loading');
			},
			error:function(){
				hide(question);
				modal.alert('Wystąpił błąd ładowania formularza odpowiedzi. Prosimy spróbować później');
			}
		});
	}
	function sendSuccess(question){
		var div=$('#answer-form-box-'+question+' .success-answer');
		loadFormSuccess(question, true);

		if(div.length){
			var name='qa'+question;
			var value=div.data('answer-token')+'|'+div.html();
			var expires=1/24/60*parseInt(div.data('time'));
			localStorage.setItem(name, value, expires);
		}
	}
	function send(form){
		loading.start();
		var question=form.data('question');
		login.checkUniqueNick(function(){
			loading.start();
			form.ajaxSubmit({
				url:'/product-answer-form.ltr',
				data:{
					ACTION:'SAVE',
					questionToken:question
				},
				type:'POST',
				target:'#answer-form-box-'+question,
				beforeSubmit: function (payload) {
					const content = payload.find(el => el.name == 'content');
					content.value = text.clean(content.value);
				},
				success:function(){
					sendSuccess(question);
				},
				error:function(){
					modal.alert('Wystąpił błąd zapisu odpowiedzi. Prosimy spróbować później');
				},
				complete:function(){
					loading.stop();
				}
			});
		}, 'odpowiedzi');
	}
	function hide(token){
		$('#question-'+token).removeClass('show-answers');
	}
	function show(token){
		$('#question-'+token).addClass('show-answers');
	}
	function load(ajaxData,option){
		if(!option){
			option={};
		}
		var data={
			singlePage: true
		};
		$.extend(true,data,ajaxData);
		show(data.questionToken);
		var div=$('#answer-list-'+data.questionToken);
		div.addClass('loading');
		$.ajax({
			url:'/front-product-answers.ltr',
			type:'GET',
			data:data,
			success:function(html){
				if(data.singlePage && data.pageNr>1){
					div.find('.more-load-answers-box').remove();
					div.append(html);
				}else{
					div.html(html);
				}
				if(option.callback){
					option.callback();
				}
				$('#answer-list-'+data.questionToken+' .answer-item').each(function(){
					comment.addInfo($(this).attr('id').substr(7));
				});
			},
			complete:function(){
				div.removeClass('loading');
			},
			error:function(){
				hide(data.questionToken);
				modal.alert('Wystąpił błąd. Prosimy spróbować później');
			}
		});
	}
	function voteHelpful(status,token){
		var data={
			answerToken:token,
			isHelpful:status
		};
		var voting=(localStorage.getItem('answerVoting') || "").split('|');
		if($.inArray(token,voting)>-1){
			modal.alert('Już oceniałeś przydatność tej odpowiedzi');
		}else{
			var $div=$('#measure-box-'+token);
			if(!$div.hasClass('loading')){
				var yes=$('.js-measure-positive', $div);
				var no=$('.js-measure-negative', $div);
				$div.addClass('waiting');
				$.ajax({
					url:'/front-product-answer-helpful.ltr',
					method:'POST',
					data:data,
					success:function(json){
						try{
							json=json.helpfulDataUpdated;
							voting.push(token);
							localStorage.setItem('answerVoting',voting.join('|'),90);
							yes.text(json.helpful);
							no.text(json.notHelpful);
						}catch(e){}
					},
					complete:function(){
						$div.removeClass('waiting');
					},
					error:function(){
						modal.alert('Wystąpił błąd. Prosimy spróbować później');
					}
				});
			}
		}
	}
	function showFormAction(form){
		form.addClass('show-buttons');
	}
	function hideFormAction(form){
		form.removeClass('show-buttons');
	}

	return {
		loadForm:loadForm,
		load:load,
		hide:hide,
		showFormAction:showFormAction,
		hideFormAction:hideFormAction,
		vote:voteHelpful,
		addInfo:addInfo
	};
});
